import SecureLS from "secure-ls";

const secureStorage = new SecureLS({ encodingType: "base-64" });

export default secureStorage;
